exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".infoContainer_2k4jZ {\n    padding: 0 80px;\n}\n\n.infoContainer_2k4jZ > h3 {\n    text-align: center;\n    font-weight: 800;\n}\n\n.sectionSubList_1AUjw {\n    list-style: none;\n    position: relative;\n}\n\n.sectionListChild_OavJ- {\n    margin-top: 10px;\n    margin-bottom: 10px;\n}\n\n.sectionListChild_OavJ- input {\n    position: absolute;\n    left: 10px;\n    line-height: 20px;\n}\n\n.descriptionConent_3-leN {\n    letter-spacing: 0.4px;\n    font-size: 16px;\n    line-height: 30px;\n}\n\n.divition_2ZSZ7 {\n    margin: 10px 0;\n    border-top: 5px solid #040404;\n}\n\n.gapSection13_1b97- {\n    height: 580px;\n}\n\n.alignment_24bZP {\n    padding-top: 30px;\n}\n\n.signatureLeft_3AU1x {\n    margin: 0 !important;\n}\n\n.datePickerRight_38dRG {\n    margin: 0 0 0 78px !important;\n}\n\n.signatureSize_3BgaZ img {\n    max-width: 200px;\n    max-height: 80px;\n}", ""]);

// exports
exports.locals = {
	"infoContainer": "infoContainer_2k4jZ",
	"sectionSubList": "sectionSubList_1AUjw",
	"sectionListChild": "sectionListChild_OavJ-",
	"descriptionConent": "descriptionConent_3-leN",
	"divition": "divition_2ZSZ7",
	"gapSection13": "gapSection13_1b97-",
	"alignment": "alignment_24bZP",
	"signatureLeft": "signatureLeft_3AU1x",
	"datePickerRight": "datePickerRight_38dRG",
	"signatureSize": "signatureSize_3BgaZ"
};